export default "__VITE_ASSET__36ff5d7b__"